/**
 * The conditions an internal harvest permit is granted on, and the harvest report checks
 * (owner, 2026-09-27: "Harvest Permits (Internal), Harvest Report (Internal)"). The FSC
 * smallholder group rules in plain words; an organisation marks the ones that apply.
 */
export const HARVEST_CONDITIONS = [
  { id: 'trees_marked', label: 'Trees to be felled marked and counted before felling' },
  { id: 'buffers_kept', label: 'Stream, HCV and boundary buffers marked; no felling inside them' },
  { id: 'directional_felling', label: 'Directional felling, away from buffers, houses and neighbours' },
  { id: 'ppe', label: 'Crew wears PPE: helmet, boots, gloves, chainsaw chaps' },
  { id: 'first_aid', label: 'First-aid kit and a trained person on site' },
  { id: 'no_child_labour', label: 'No worker under 18 on the felling crew' },
  { id: 'no_burning', label: 'No burning of residue; left to decompose or used' },
  { id: 'fd_permit_in_hand', label: 'Forest Department permit / transit pass in hand before transport' },
  { id: 'regeneration', label: 'Replanting or regeneration of the felled area committed' },
];
